import { Outlet, useLocation } from 'react-router-dom';
import Footer from './Footer';
import NavBar from './NavBar';

const Layout = () => {
  const location = useLocation();
  const isHomePage = location.pathname === '/';

  return (
    <div>
      {isHomePage && <NavBar />}
      <main style={{ flex: 1 }}>
        <Outlet />
      </main>
      {isHomePage && <Footer />}
    </div>
  );
};

export default Layout;
